import { render, staticRenderFns } from "./Reserva.vue?vue&type=template&id=37f8b236&"
import script from "./Reserva.vue?vue&type=script&lang=js&"
export * from "./Reserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDivider,
  VFlex,
  VLayout,
  VProgressCircular,
})
